module.exports = __webpack_public_path__ + "static/media/twitter.7a4d9f0f.svg";